import api from "@/services/api";

const state = {
  employees: [],
};

const mutations = {
  SET_EMPLOYEES(state, employees) {
    state.employees = employees;
  },
};

const actions = {
  async getEmployees({ commit }) {
    try {
      const res = await api.get("/employees");
      commit("SET_EMPLOYEES", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching employees:", error.message);
      throw error;
    }
  },

  async createEmployee({ dispatch }, employeeData) {
    try {
      const result = await api.post("/employees", employeeData);
      await dispatch("getEmployees");
      return result.data;
    } catch (error) {
      console.error("Error creating employee:", error.message);
      throw error;
    }
  },

  async updateEmployee({ dispatch }, { id, employeeData }) {
    try {
      const result = await api.put(`/employees/${id}`, employeeData);
      await dispatch("getEmployees");
      return result.data;
    } catch (error) {
      console.error("Error updating employee:", error.message);
      throw error;
    }
  },

  async deactivateEmployee({ dispatch }, id) {
    try {
      const result = await api.put(`/employees/${id}/deactivate`);
      await dispatch("getEmployees");
      return result.data;
    } catch (error) {
      console.error("Error deactivating employee:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
